var _templateObject = _taggedTemplateLiteralLoose(['\n  color: #fff;\n  text-decoration: none;\n  font-family: ', ';\n  font-weight: 500;\n  font-size: 15px;\n  width: 100%;\n  flex-grow: 45;\n  position: relative;\n\n  &.active {\n    font-weight: 700;\n  }\n\n  &.active::before {\n    content: "";\n    position: absolute;\n    vertical-align: middle;\n    width: 100%;\n    color: ', ';\n    left: ', 'px;\n    right: ', 'px;\n    bottom: ', 'px;\n    border-bottom: 4px solid;\n    @media (max-width: 992px) {\n      bottom: -5px;\n    }\n  }\n\n  &.active:hover {\n    text-decoration: none;\n    color: #fff;\n  }\n  &:hover {\n    text-decoration: none;\n    color: ', ';\n  }\n'], ['\n  color: #fff;\n  text-decoration: none;\n  font-family: ', ';\n  font-weight: 500;\n  font-size: 15px;\n  width: 100%;\n  flex-grow: 45;\n  position: relative;\n\n  &.active {\n    font-weight: 700;\n  }\n\n  &.active::before {\n    content: "";\n    position: absolute;\n    vertical-align: middle;\n    width: 100%;\n    color: ', ';\n    left: ', 'px;\n    right: ', 'px;\n    bottom: ', 'px;\n    border-bottom: 4px solid;\n    @media (max-width: 992px) {\n      bottom: -5px;\n    }\n  }\n\n  &.active:hover {\n    text-decoration: none;\n    color: #fff;\n  }\n  &:hover {\n    text-decoration: none;\n    color: ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  ', ';\n'], ['\n  ', ';\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  ', ';\n  cursor: pointer;\n'], ['\n  ', ';\n  cursor: pointer;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: ', ';\n  width: 100%;\n  flex-grow: 1;\n  white-space: nowrap;\n'], ['\n  display: flex;\n  flex-direction: ', ';\n  width: 100%;\n  flex-grow: 1;\n  white-space: nowrap;\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  padding: 15px 10px;\n  @media (min-width: 992px) {\n    padding: 10px 10px;\n  }\n  @media (min-width: 1200px) {\n    padding: 10px 15px;\n  }\n  ', '\n'], ['\n  padding: 15px 10px;\n  @media (min-width: 992px) {\n    padding: 10px 10px;\n  }\n  @media (min-width: 1200px) {\n    padding: 10px 15px;\n  }\n  ', '\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled, { css } from 'styled-components';
import { greyBlue, gold } from '../../assets/colors';
import { Montserrat } from '../../assets/fonts';
import getPgaTld from '../../getPgaTld';
import handleMailClick from '../HeaderMailModal/handleMailClick';
import Subnav from './Subnav';

var LinkCss = css(_templateObject, Montserrat, gold, function (props) {
  return props.l;
}, function (props) {
  return props.r;
}, function (props) {
  return props.b;
}, gold);
export var LinkFrame = styled.a.attrs(function (props) {
  return {
    href: props.to,
    rel: function rel(props) {
      return props.external ? 'noopener noreferrer' : null;
    }
  };
})(_templateObject2, LinkCss);
export var EmailText = styled.div(_templateObject3, LinkCss);
export var NavFrame = styled.nav(_templateObject4, function (props) {
  return props.vertical && 'column' || 'row';
});

var pgaTld = getPgaTld();

export var RedirectToLogin = function RedirectToLogin(_ref) {
  var label = _ref.label;
  return React.createElement(
    EmailText,
    { onClick: function onClick() {
        return window.location.assign('https://account.' + pgaTld + '/login?return_to=https://account.' + pgaTld + '/mail-redirect');
      } },
    label
  );
};

export var mapLinks = function mapLinks(options, comp, vertical, b, l, _ref2) {
  var isLoggedIn = _ref2.isLoggedIn,
      meEmailMigrationData = _ref2.meEmailMigrationData,
      setModalType = _ref2.setModalType,
      setOpen = _ref2.setOpen;

  return options && options.map(function (option) {
    var to = option.to,
        _option$label = option.label,
        label = _option$label === undefined ? '' : _option$label,
        target = option.target,
        root = option.root,
        external = option.external;

    var LinkComponent = comp && !external ? comp : LinkFrame;
    return React.createElement(
      LinkBox,
      { key: label, vertical: vertical },
      option.options ? React.createElement(Subnav, { option: option, comp: comp }) : label.toLowerCase() === 'my email' ? !isLoggedIn ? React.createElement(RedirectToLogin, { label: label }) : React.createElement(
        EmailText,
        { onClick: function onClick() {
            return handleMailClick({ meEmailMigrationData: meEmailMigrationData, setModalType: setModalType, setOpen: setOpen });
          } },
        label
      ) : React.createElement(
        LinkComponent,
        { exact: true, key: to, to: to, target: target, b: b, l: l, className: (root && 'active') + ' pga-nav', external: external },
        label
      )
    );
  });
};

export var LinkBox = styled.div(_templateObject5, function (props) {
  return props.vertical && '\n    &:not(:last-child) {\n      border-bottom: 2px solid ' + greyBlue + ';\n    }\n  ';
});